module.exports = __webpack_public_path__ + "img/tasks-statuses.a02fd758.svg";